import hourGlassDarkIcon from '@assets/misc/hour-glass-dark.svg';
import hourGlassLightIcon from '@assets/misc/hour-glass-icon.svg';
import zapIconLight from '@assets/misc/zap-icon-light.svg';
import zapIcon from '@assets/misc/zap-icon.svg';
import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface GenericFormAlertProps {
  icon?: ReactNode;
  title?: string;
  caption: ReactNode;
  theme?: 'dark' | 'light';
}

function GenericFormAlert(props: GenericFormAlertProps) {
  const { icon, title, caption, theme = 'dark' } = props;

  const themeBased = {
    backgroundColor: theme === 'dark' ? 'primary.dark' : 'primary.light',
    zapIcon: theme === 'dark' ? zapIcon : zapIconLight,
    topIcon: theme === 'dark' ? hourGlassLightIcon : hourGlassDarkIcon,
    fontColor: theme === 'dark' ? 'bg.white' : 'font.dark'
  };

  return (
    <Box sx={{ p: '0 1.5rem' }}>
      <Box
        sx={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          backgroundColor: themeBased.backgroundColor,
          borderRadius: '16px',
          width: '100%',
          rowGap: '1.5rem',
          pt: '18px',
          pb: '17px',
          position: 'relative',
          overflowY: 'hidden'
        }}>
        <img
          src={themeBased.zapIcon}
          style={{ position: 'absolute', left: '10%', top: 0 }}
          alt="Zap Icon"
        />
        {icon ?? <img src={themeBased.topIcon} alt="Top Icon" />}
        <Box
          sx={{
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            rowGap: '.75rem',
            zIndex: 1
          }}>
          {title && (
            <Typography variant="body1" sx={{ color: themeBased.fontColor, fontWeight: '700' }}>
              {title}
            </Typography>
          )}
          {caption}
        </Box>
        <img
          src={themeBased.zapIcon}
          style={{ position: 'absolute', right: '0', bottom: '-47%' }}
          alt="Zap Icon"
        />
      </Box>
    </Box>
  );
}

export default GenericFormAlert;
